import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAGAB020, postPAGAB020Regis, postPAGAB020Reply, postPAGAB020ReplyDelete, putPAGAB020CommentLike, putPAGAB020CommentLikeV2, putPAGAB020Reply, submitEvent } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_DENTAL_PLUS, BASE_URL } from '../../../shared/constants/app';
import { decodeToken, formatDate, handleFocus, updateMenuVisibility } from '../../../utils';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';


const PAGAB020 = () => {
    const navigate = useNavigate();
    const { id } = useParams({});
    const [data, setData] = useState({});
    const [dataRegisterList, setDataRegisterList] = useState([]);
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [review, setReview] = useState('');
    const reviewInputRef = useRef(null);
    const [replyTargetSeq, setReplyTargetSeq] = useState(null);
    const [replyText, setReplyText] = useState('');
    const [editingReplySeq, setEditingReplySeq] = useState(null);
    const [editingReplyText, setEditingReplyText] = useState('');
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);
    const login = useSelector(({ auth }) => auth.login);
    const isLoggedIn = login.loggedIn;
    const token = decodeToken(login.token);

    const [questions, setQuestions] = useState([]);
    const [surveyAnswers, setSurveyAnswers] = useState({});
    const [surveyShortAnswers, setSurveyShortAnswers] = useState({});
    const [selectedGift, setSelectedGift] = useState('');

    const validGifts = (data?.gifts || []).filter(gift => gift?.giftName?.trim());
    const hasValidGift = (data?.gifts || []).some(gift => gift?.giftName?.trim());

    const isRegistered = data?.isRegistered === 'Y';
    const isEnded = data?.isEnd === 'Y';
    const currentMemberId = token?.memberId || token?.memberID || token?.username || token?.sub;

    const likeBufferRef = useRef({});
    const likeTimerRef = useRef({});

    const maskMemberId = (memberId) => {
        if (!memberId) return '';
        const id = String(memberId);
        if (id.length <= 4) return id;
        return id.slice(0, 4) + '*'.repeat(id.length - 4);
    };

    const getLikedKey = (eventId) => `liked_comments_${eventId}`;

    const getLocalLiked = (eventId) => {
        try {
            return JSON.parse(localStorage.getItem(getLikedKey(eventId)) || '[]');
        } catch {
            return [];
        }
    };

    const addLocalLiked = (eventId, seq) => {
        const liked = getLocalLiked(eventId);
        if (!liked.includes(seq)) {
            localStorage.setItem(getLikedKey(eventId), JSON.stringify([...liked, seq]));
        }
    };

    const canManageComment = (comment) => {
        return (
            comment?.isMine === 'Y' ||
            comment?.isOwner === 'Y' ||
            comment?.myCommentYn === 'Y' ||
            comment?.memberId === currentMemberId
        );
    };

    const getCommentSeq = (comment) => {
        return comment?.seq || comment?.Seq;
    };

    const getCommentParentSeq = (comment) => {
        return comment?.parentSeq || comment?.ParentSeq || comment?.parents || comment?.parentCommentSeq || comment?.parentReviewSeq;
    };

    const getCommentReplies = (comment) => {
        return comment?.replies || comment?.children || comment?.replyList || comment?.childList || [];
    };

    const normalizeComment = (comment) => {
        const seq = getCommentSeq(comment);
        const parentSeq = getCommentParentSeq(comment);

        return {
            ...comment,
            seq,
            Seq: comment?.Seq || seq,
            ...(parentSeq ? { parentSeq } : {}),
        };
    };

    const getCurrentDateTime = () => {
        const now = new Date();
        const pad = (value) => String(value).padStart(2, '0');

        return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    };

    const formatCommentDateTime = (date) => {
        if (!date) {
            return getCurrentDateTime();
        }

        const commentDate = new Date(date);

        if (Number.isNaN(commentDate.getTime())) {
            return date;
        }

        const pad = (value) => String(value).padStart(2, '0');

        return `${commentDate.getFullYear()}-${pad(commentDate.getMonth() + 1)}-${pad(commentDate.getDate())} ${pad(commentDate.getHours())}:${pad(commentDate.getMinutes())}:${pad(commentDate.getSeconds())}`;
    };

    const normalizeRegisterList = (list) => {
        const parentMap = new Map();
        const parents = [];
        const flatReplies = [];

        list.forEach((comment) => {
            const normalizedComment = normalizeComment(comment);
            const parentSeq = getCommentParentSeq(normalizedComment);

            if (parentSeq) {
                flatReplies.push(normalizedComment);
                return;
            }

            const parent = {
                ...normalizedComment,
                replies: getCommentReplies(normalizedComment).map(normalizeComment),
            };

            parentMap.set(String(getCommentSeq(parent)), parent);
            parents.push(parent);
        });

        flatReplies.forEach((reply) => {
            const parent = parentMap.get(String(getCommentParentSeq(reply)));

            if (parent) {
                parent.replies = [...getCommentReplies(parent), normalizeComment(reply)];
            }
        });

        return parents;
    };

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        if (!review && reviewInputRef.current?.innerText) {
            reviewInputRef.current.innerText = '';
        }
    }, [review]);


    const handleCommentLike = (seq) => {
        addLocalLiked(id, seq);
        setDataRegisterList(prev =>
            prev.map(item => {
                if (item.seq === seq) {
                    return { ...item, likeCnt: (item.likeCnt || 0) + 1, isLiked: 'Y' }
                }
                return {
                    ...item,
                    replies: getCommentReplies(item).map(reply =>
                        reply.seq === seq
                            ? { ...reply, likeCnt: (reply.likeCnt || 0) + 1, isLiked: 'Y' }
                            : reply
                    )
                };
            })
        );

        likeBufferRef.current[seq] = (likeBufferRef.current[seq] || 0) + 1;

        if (likeTimerRef.current[seq]) clearTimeout(likeTimerRef.current[seq]);

        likeTimerRef.current[seq] = setTimeout(() => {
            const count = likeBufferRef.current[seq] || 0;
            if (count === 0) return;

            delete likeBufferRef.current[seq];
            delete likeTimerRef.current[seq];

            putPAGAB020CommentLikeV2(seq, count)
                .catch(error => {
                    console.error(error);
                    // rollback
                    setDataRegisterList(prev =>
                        prev.map(item => {
                            if (item.seq === seq) {
                                return { ...item, likeCnt: (item.likeCnt || 0) - count, isLiked: 'N' };
                            }
                            return {
                                ...item,
                                replies: getCommentReplies(item).map(reply =>
                                    reply.seq === seq
                                        ? { ...reply, likeCnt: (reply.likeCnt || 0) - count, isLiked: 'N' }
                                        : reply
                                )
                            };
                        })
                    );
                });
        }, 500);
    };


    const handleInputChange = (e) => {
        setReview(e.currentTarget.innerText.replace(/\u00a0/g, ' '));
    };

    const handleCommentInputPaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    };

    const handleReplyOpen = (seq, isReplied) => {
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        if (isReplied === 'Y') {
            alert('이미 해당 댓글에 대댓글을 작성하셨습니다.');
            return;
        }
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }

        setReplyTargetSeq(seq);
        setReplyText('');
    };

    const handleReplyCancel = () => {
        setReplyTargetSeq(null);
        setReplyText('');
    };

    const handleReplySubmit = (commentSeq) => {
        if (!replyText.trim()) {
            alert('댓글 내용을 입력해 주세요.');
            return;
        }

        postPAGAB020Reply({
            eventSeq: Number(id),
            parentSeq: commentSeq,
            review: replyText,
        })
            .then(({ data }) => {
                const responseReply = data?.data || data?.reply || data?.result || data;
                const reply = normalizeComment(typeof responseReply === 'object' && responseReply !== null ? responseReply : {});
                const replySeq = getCommentSeq(reply) || `temp-${Date.now()}`;
                const nextReply = {
                    ...reply,
                    seq: replySeq,
                    Seq: reply.Seq || replySeq,
                    parentSeq: getCommentParentSeq(reply) || commentSeq,
                    memberId: reply.memberId || currentMemberId,
                    review: reply.review || replyText,
                    addDate: formatCommentDateTime(reply.addDate),
                    likeCnt: reply.likeCnt || 0,
                    isLiked: reply.isLiked || 'N',
                    isMine: reply.isMine || 'Y',
                };

                setDataRegisterList(prevList =>
                    prevList.map(item => {
                        if (item.seq !== commentSeq) {
                            return item;
                        }

                        return {
                            ...item,
                            isReplied: 'Y',
                            replies: [nextReply, ...getCommentReplies(item)]
                        };
                    })
                );
                setReplyTargetSeq(null);
                setReplyText('');
            })
            .catch((error) => {
                console.log(error);
                alert('오류 발생했습니다.');
            });
    };

    const handleCommentEditOpen = (comment) => {
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }
        setEditingReplySeq(comment?.seq);
        setEditingReplyText(comment?.review || '');
    };

    const handleCommentEditCancel = () => {
        setEditingReplySeq(null);
        setEditingReplyText('');
    };

    const handleCommentEditSubmit = (commentSeq) => {
        if (!editingReplyText.trim()) {
            alert('댓글 내용을 입력해 주세요.');
            return;
        }

        const commentSeqNumber = Number(commentSeq);

        if (!commentSeq || Number.isNaN(commentSeqNumber)) {
            alert('댓글 정보가 올바르지 않습니다.');
            return;
        }

        putPAGAB020Reply({
            seq: commentSeqNumber,
            review: editingReplyText,
        })
            .then(() => {
                setDataRegisterList((prevList) =>
                    prevList.map((item) => {
                        if (Number(item.seq) === commentSeqNumber) {
                            return {
                                ...item,
                                review: editingReplyText,
                            };
                        }

                        return {
                            ...item,
                            replies: getCommentReplies(item).map((reply) => {
                                if (Number(reply.seq) !== commentSeqNumber) {
                                    return reply;
                                }

                                return {
                                    ...reply,
                                    review: editingReplyText,
                                };
                            }),
                        };
                    }),
                );
                setEditingReplySeq(null);
                setEditingReplyText('');
            })
            .catch((error) => {
                console.log(error);
                alert(error?.response?.data?.message || '오류 발생했습니다.');
            });
    };

    // const handleCommentDelete = (commentSeq) => {
    //     if (!window.confirm('댓글을 삭제하시겠습니까?')) {
    //         return;
    //     }

    //     const commentSeqNumber = Number(commentSeq);

    //     if (!commentSeq || Number.isNaN(commentSeqNumber)) {
    //         alert('댓글 정보가 올바르지 않습니다.');
    //         return;
    //     }

    //     postPAGAB020ReplyDelete(commentSeqNumber)
    //         .then(() => {
    //             setDataRegisterList((prevList) =>
    //                 prevList
    //                     .filter((item) => Number(item.seq) !== commentSeqNumber)
    //                     .map((item) => ({
    //                         ...item,
    //                         replies: getCommentReplies(item).filter((reply) => Number(reply.seq) !== commentSeqNumber),
    //                     })),
    //             );
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             alert(error?.response?.data?.message || '오류 발생했습니다.');
    //         });
    // };

    const handlePostComment = () => {
        if (isRegistered) {
            alert('본 이벤트는 1인 1회만 댓글 작성이 가능합니다.');
            return;
        }
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }
        if (!review) {
            alert('댓글 내용을 입력해 주세요.');
            return;
        }

        if (!isRegistered && hasValidGift > 0 && !selectedGift) {
            alert('사은품을 선택해주세요.');
            return;
        }

        postPAGAB020Regis({
            eventSeq: id,
            review,
            ...(
                !isRegistered &&
                    data?.gifts?.length > 0 &&
                    selectedGift
                    ? { giftId: Number(selectedGift) }
                    : {}
            ),
        })
            .then(({ data }) => {
                const responseComment = data?.data || data?.result || data;
                const comment = normalizeComment(typeof responseComment === 'object' && responseComment !== null ? responseComment : {});
                const commentSeq = getCommentSeq(comment) || `temp-${Date.now()}`;
                const newComment = {
                    ...comment,
                    seq: commentSeq,
                    Seq: comment.Seq || commentSeq,
                    memberId: comment.memberId || currentMemberId,
                    review: comment.review || review,
                    addDate: formatCommentDateTime(comment.addDate),
                    likeCnt: comment.likeCnt || 0,
                    isLiked: comment.isLiked || 'N',
                    isMine: comment.isMine || 'Y',
                    replies: getCommentReplies(comment).map(normalizeComment),
                };

                setData(prev => ({
                    ...prev,
                    isRegistered: 'Y'
                }));
                setDataRegisterList(prev => [newComment, ...prev]);
                setReview('');
            })
            .catch((error) => {
                if (error.response && error.response.status === 400) {
                    window.alert('참여 대상이 아닌 이벤트입니다.');
                    handleFocus('review');
                } else {
                    console.log(error);
                }
            });
    };

    const handleSubmitEvent = () => {
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        const emptyQuestion = questions.find((question) => {
            const answers = surveyAnswers[question.seq] || [];
            const shortAnswer = surveyShortAnswers[question.seq]?.trim() || '';

            return answers.length === 0 && !(question.shortAnswerYn === 'Y' && shortAnswer);
        });

        if (emptyQuestion) {
            alert('선택되지 않은 문항이 있습니다.');

            const targetTable = document.querySelector(
                `[data-question-seq="${emptyQuestion.seq}"]`
            );

            targetTable?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });

            const firstInput = targetTable?.querySelector('input');
            firstInput?.focus();

            return;
        }

        let emptyEtc = null;

        for (const question of questions) {
            const answers = surveyAnswers[question.seq] || [];

            const etcOption = (question.options || []).find(
                (option) =>
                    option.optionText === '기타(직접입력)' &&
                    answers.includes(option.optionId) &&
                    !(surveyShortAnswers[`${question.seq}_${option.optionId}`]?.trim())
            );

            if (etcOption) {
                emptyEtc = { question, optionId: etcOption.optionId };
                break;
            }
        }

        if (emptyEtc) {
            alert('기타 항목의 내용을 입력해 주세요.');

            const targetTable = document.querySelector(
                `[data-question-seq="${emptyEtc.question.seq}"]`
            );

            targetTable?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });

            const etcInput = targetTable?.querySelector('.event-survey__etc');
            etcInput?.focus();

            return;
        }

        if (hasValidGift && !selectedGift) {
            alert('사은품을 선택해주세요.');
            return;
        }

        const selectedAnswers = Object.entries(surveyAnswers).flatMap(([questionSeq, optionIds]) => {
            const question = questions.find((q) => q.seq === Number(questionSeq));

            return optionIds.map((optionId) => {
                const etcOption = (question?.options || []).find(
                    (opt) => opt.optionId === optionId && opt.optionText === '기타(직접입력)'
                );
                const answerContent = etcOption
                    ? surveyShortAnswers[`${questionSeq}_${optionId}`]?.trim() || ''
                    : '';

                return {
                    questionSeq: Number(questionSeq),
                    optionId: Number(optionId),
                    answerContent,
                };
            });
        });

        const requestData = {
            eventSeq: Number(id),
            ...(data?.gifts?.length > 0 && selectedGift
                ? { giftId: Number(selectedGift) }
                : {}),
            answers: selectedAnswers,
        };

        submitEvent(requestData)
            .then(() => {
                alert('참여가 완료 되었습니다.\n이벤트에 참여해 주셔서 감사합니다.');
                navigate('/pagab010');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getListData = () => {
        postPAGAB020(id, { page })
            .then(({ data }) => {
                const eventDetail = data.eventDetail || {};
                const localLiked = getLocalLiked(id);

                const normalized = normalizeRegisterList(data.registerList?.data || []).map(item => ({
                    ...item,
                    isLiked: localLiked.includes(item.seq) ? 'Y' : item.isLiked,
                    replies: getCommentReplies(item).map(reply => ({
                        ...reply,
                        isLiked: localLiked.includes(reply.seq) ? 'Y' : reply.isLiked,
                    })),
                }));

                setData(eventDetail);
                setQuestions(eventDetail.questions || []);
                setDataRegisterList(normalized);
                setPages(data.registerList?.info || {});
            })
            .catch((error) => console.log(error));
    };

    const handleSurveyAnswerChange = (question, optionId, checked) => {
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }

        setSurveyAnswers((prev) => {
            const currentAnswers = prev[question.seq] || [];

            if (question.type === 'S') {
                return {
                    ...prev,
                    [question.seq]: [optionId],
                };
            }

            if (question.type === 'M') {
                if (checked) {

                    return {
                        ...prev,
                        [question.seq]: [...currentAnswers, optionId],
                    };
                }

                return {
                    ...prev,
                    [question.seq]: currentAnswers.filter((id) => id !== optionId),
                };
            }

            return prev;
        });
    };

    const handleSurveyShortAnswerChange = (questionSeq, value) => {
        setSurveyShortAnswers((prev) => ({
            ...prev,
            [questionSeq]: value,
        }));
    };

    // Etc-only 문항: 체크박스 없이 입력만 받으므로 입력값에 따라 선택 상태(answers)를 동기화한다.
    const handleEtcOnlyChange = (question, optionId, value) => {
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }

        handleSurveyShortAnswerChange(`${question.seq}_${optionId}`, value);

        setSurveyAnswers((prev) => ({
            ...prev,
            [question.seq]: value.trim() ? [optionId] : [],
        }));
    };

    const handleGiftChange = (e) => {
        if (!isLoggedIn) {
            alert('로그인 후 참여하실 수 있습니다.');
            return;
        }
        if (isEnded) {
            alert('해당 이벤트는 종료되었습니다.');
            return;
        }
        setSelectedGift(e.target.value);
    };

    useEffect(() => {
        getListData();
    }, [id, page]);

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="tableVolunteer">
                <h3 className="vln__tit">이벤트</h3>
                <div className="vln-edtl">
                    <div className="vln-edtl__tit">
                        <div className="vln-edtl-lf">
                            <span className={data?.isEnd === 'Y' ? 'gray' : ''}>
                                {data?.isEnd === 'Y' ? '마감' : '진행중'}
                            </span>
                            <p>{data?.title}</p>
                        </div>
                        <div className="vln-edtl__date">
                            {formatDate(data?.startDate)} ~ {formatDate(data?.endDate)}
                        </div>
                    </div>
                    {/* <div className="vln-edtl__cnt">
                        <ImageCheckFallback folderName="event" imgName={data?.webImg} alt="Event" />
                    </div> */}
                    <div className="vln-edtl__cnt" dangerouslySetInnerHTML={{ __html: data?.contents }}></div>
                    <a
                        href={data?.surveyLink}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            display: 'block',
                            marginTop: '20px',
                            color: '#0068b7',
                            textDecoration: 'underline',
                            fontSize: '17px',
                        }}
                    >
                        {data?.surveyLink}
                    </a>
                </div>
                {data?.eventGbn === 'RVW' && (
                    <>
                        <div className="vln-btnbx">
                            <Link to="/pagab010" className="vln-listbtn">
                                목록
                            </Link>
                        </div>
                        {/* {(data.target === 'A' || data.target === token?.authorities.split('_')[1]) && ( */}
                        <div className="cmnt">
                            <>
                                <h4 className="cmnt__tit">
                                    참여 댓글 : {dataRegisterList?.length ? dataRegisterList?.length : 0}개
                                </h4>
                                {data?.isEnd !== 'Y' && (
                                    <div className="cmnt__block">
                                        <div
                                            className="cmnt__input-wrap"
                                            onClick={() => reviewInputRef.current?.focus()}
                                        >
                                            <div
                                                id="review"
                                                ref={reviewInputRef}
                                                className="cmnt__input"
                                                contentEditable
                                                role="textbox"
                                                aria-label="대한민국 치과계 No.1 구인구직 사이트 덴탈잡"
                                                aria-multiline="true"
                                                suppressContentEditableWarning
                                                onInput={handleInputChange}
                                                onPaste={handleCommentInputPaste}
                                            />
                                            {!review && (
                                                <span className="cmnt__placeholder">
                                                    대한민국 치과계 No.1 구인구직 사이트 덴탈잡
                                                </span>
                                            )}
                                        </div>
                                        <button type="button" className="cmnt__reg" onClick={handlePostComment}>
                                            등록
                                        </button>
                                    </div>
                                )}


                                {validGifts.length > 0 && (
                                    <div className="event-gift" style={{ maxWidth: '100%', padding: '15px 130px' }}>
                                        {/* {isRegistered ? (
                                            <h4 className="event-gift__title">사은품</h4>
                                        ) : (
                                            <h4 className="event-gift__title">사은품 선택</h4>
                                        )} */}
                                        <h4 className="event-gift__title">사은품 선택</h4>

                                        <div className="event-gift__list">
                                            {validGifts.map((gift) => (
                                                <label
                                                    className="event-gift__item"
                                                    htmlFor={`event-gift-${gift.giftId}`}
                                                    key={gift.giftId}
                                                >
                                                    {!isRegistered ? (
                                                        <>
                                                            <input
                                                                id={`event-gift-${gift.giftId}`}
                                                                type="radio"
                                                                name="event-gift"
                                                                value={gift.giftId}
                                                                onChange={handleGiftChange}
                                                            />
                                                            <span
                                                                className="event-gift__check"
                                                                aria-hidden="true"
                                                            />
                                                        </>
                                                    ) : (
                                                        <span />
                                                    )}


                                                    {gift.webImgName && (
                                                        <span className="event-gift__thumb">
                                                            <img
                                                                src={`${BASE_URL}/gift/${gift.webImgName}`}
                                                                alt={gift.giftName}
                                                            />
                                                        </span>
                                                    )}


                                                    <span className="event-gift__label">
                                                        {gift.giftName}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </>

                            <ul className="cmnt__list">
                                {dataRegisterList && dataRegisterList.length > 0 ? (
                                    dataRegisterList.map((item, index) => {
                                        const replies = getCommentReplies(item);
                                        const isEditingComment = editingReplySeq === item?.seq;
                                        const showCommentManageActions = canManageComment(item);
                                        const commentSeq = getCommentSeq(item);

                                        return (
                                            <li className="cmnt__item" key={`cmnt-${commentSeq || index}`}>
                                                <div className="cmnt__seq-col">
                                                    <span className="cmnt__seq">{dataRegisterList.length - index}</span>
                                                    {/* <span className="cmnt__seq">{index + 1}</span> */}
                                                </div>
                                                <div className="cmnt__body">
                                                    <div className="cmnt__top">
                                                        <div className="cmnt__lf">
                                                            {/* <img
                                                                className="cmnt__img"
                                                                src="./images/icons/icon-nav-user.png"
                                                                alt="sample"
                                                            /> */}
                                                            <span>{maskMemberId(item?.memberId)}</span>
                                                        </div>
                                                        <div className="cmnt__bottom">
                                                            <div className="cmnt__meta">
                                                                <div className="cmnt__date">{item?.addDate?.slice(0, 16)}</div>
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__like"
                                                                    onClick={() => handleCommentLike(item?.seq)}
                                                                >

                                                                    {item?.isLiked === 'Y' ? (
                                                                        <img
                                                                            className="filled"
                                                                            src="./images/icons/iconmonstr-heart-filled-64.png"
                                                                            alt="sample"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            className="lined"
                                                                            src="./images/icons/iconmonstr-heart-lined-64.png"
                                                                            alt="sample"
                                                                        />
                                                                    )}
                                                                </button>
                                                                {item?.likeCnt > 0 && (
                                                                    <span className="cmnt__like-count">{item.likeCnt}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {isEditingComment ? (
                                                        <div className="cmnt__edit-form">
                                                            <textarea
                                                                className="cmnt__reply-input"
                                                                value={editingReplyText}
                                                                onChange={(e) => setEditingReplyText(e.target.value)}
                                                            />
                                                            <div className="cmnt__reply-actions">
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__reply-submit"
                                                                    onClick={() => handleCommentEditSubmit(item?.seq)}
                                                                >
                                                                    저장
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__reply-cancel"
                                                                    onClick={handleCommentEditCancel}
                                                                >
                                                                    취소
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="cmnt__content">{item?.review}</div>
                                                    )}
                                                    {(showCommentManageActions || data?.replyYn === 'Y') && (
                                                        <div className="cmnt__bottom cmnt__bottom--reply">
                                                            {showCommentManageActions && (
                                                                <div className="cmnt__manage-actions">
                                                                    {/* <button
                                                                        type="button"
                                                                        onClick={() => handleCommentDelete(item?.seq)}
                                                                    >
                                                                        삭제
                                                                    </button> */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleCommentEditOpen(item)}
                                                                    >
                                                                        수정
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {data?.replyYn === 'Y' && (
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__reply"
                                                                    onClick={() => handleReplyOpen(item?.seq, item?.isReplied)}
                                                                >
                                                                    댓글 쓰기
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                    {replyTargetSeq === item?.seq && (
                                                        <div className="cmnt__reply-form">
                                                            <span className="cmnt__reply-line" />
                                                            <textarea
                                                                className="cmnt__reply-input"
                                                                placeholder="댓글을 작성해주세요."
                                                                value={replyText}
                                                                onChange={(e) => setReplyText(e.target.value)}
                                                            />
                                                            <div className="cmnt__reply-actions">
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__reply-submit"
                                                                    onClick={() => handleReplySubmit(item?.seq)}
                                                                >
                                                                    작성
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="cmnt__reply-cancel"
                                                                    onClick={handleReplyCancel}
                                                                >
                                                                    취소
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {data?.replyYn === 'Y' && replies.length > 0 && (
                                                        <ul className="cmnt__reply-list">
                                                            {replies.map((reply, replyIndex) => {
                                                                const isEditingReply = editingReplySeq === reply?.seq;
                                                                const showManageActions = canManageComment(reply);

                                                                return (
                                                                    <li className="cmnt__item cmnt__item--reply" key={`reply-${reply?.seq || replyIndex}`}>
                                                                        <div className="cmnt__top">
                                                                            <div className="cmnt__lf">
                                                                                {/* <img
                                                                                    className="cmnt__img"
                                                                                    src="./images/icons/icon-nav-user.png"
                                                                                    alt="sample"
                                                                                /> */}
                                                                                <span>{maskMemberId(reply?.memberId)}</span>
                                                                            </div>
                                                                            <div className="cmnt__bottom">
                                                                                <div className="cmnt__meta">
                                                                                    <div className="cmnt__date">{reply?.addDate}</div>

                                                                                    <button
                                                                                        type="button"
                                                                                        className="cmnt__like"
                                                                                        onClick={() => handleCommentLike(reply?.seq)}
                                                                                    >

                                                                                        {reply?.isLiked === 'Y' ? (
                                                                                            <img
                                                                                                className="filled"
                                                                                                src="./images/icons/iconmonstr-heart-filled-64.png"
                                                                                                alt="sample"
                                                                                            />
                                                                                        ) : (
                                                                                            <img
                                                                                                className="lined"
                                                                                                src="./images/icons/iconmonstr-heart-lined-64.png"
                                                                                                alt="sample"
                                                                                            />
                                                                                        )}
                                                                                    </button>
                                                                                    {reply?.likeCnt > 0 && (
                                                                                        <span className="cmnt__like-count">{reply.likeCnt}</span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {isEditingReply ? (
                                                                            <div className="cmnt__edit-form">
                                                                                <textarea
                                                                                    className="cmnt__reply-input"
                                                                                    value={editingReplyText}
                                                                                    onChange={(e) => setEditingReplyText(e.target.value)}
                                                                                />
                                                                                <div className="cmnt__reply-actions">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="cmnt__reply-submit"
                                                                                        onClick={() => handleCommentEditSubmit(reply?.seq)}
                                                                                    >
                                                                                        저장
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="cmnt__reply-cancel"
                                                                                        onClick={handleCommentEditCancel}
                                                                                    >
                                                                                        취소
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="cmnt__content">{reply?.review}</div>
                                                                        )}
                                                                        {showManageActions && (
                                                                            <div className="cmnt__bottom cmnt__bottom--reply">
                                                                                <div className="cmnt__manage-actions">
                                                                                    {/* <button
                                                                                        type="button"
                                                                                        onClick={() => handleCommentDelete(reply?.seq)}
                                                                                    >
                                                                                        삭제
                                                                                    </button> */}
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handleCommentEditOpen(reply)}
                                                                                    >
                                                                                        수정
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })
                                ) : (
                                    <span></span>
                                )}
                            </ul>
                            <Pagination pages={pages} />
                        </div>
                        {/* )} */}
                    </>
                )}

                {data?.eventGbn === 'QUE' && (
                    <>
                        {questions.map((question, questionIndex) => {
                            const answers = surveyAnswers[question.seq] || [];
                            const isSingle = question.type === 'S';
                            const isMultiple = question.type === 'M';
                            const isEtcOnly =
                                (question.options || []).length === 1 &&
                                question.options[0]?.optionText === '기타(직접입력)';

                            return (
                                <div className="event-survey" key={question.seq}>
                                    <div className="event-survey__header">
                                        <h4 className="event-survey__title">
                                            {question.title}
                                        </h4>
                                        <p className="event-survey__desc">{question.subTitle}</p>
                                    </div>

                                    <div className="event-survey__table-area">
                                        {!isEtcOnly && (
                                            <div className="event-survey__choice-guide">
                                                {isSingle && '1개 선택'}
                                                {isMultiple && '다중 선택 가능'}
                                            </div>
                                        )}

                                        <div className="event-survey__table" data-question-seq={question.seq}>
                                            {!isEtcOnly && (
                                                <div className="event-survey__row event-survey__row--head">
                                                    {!isRegistered ? <div>선택</div> : <div />}
                                                    <div>번호</div>
                                                    <div>내용</div>
                                                </div>
                                            )}


                                            {(question.options || []).map((option, index) => {
                                                const isEtc = option.optionText === '기타(직접입력)';

                                                if (isEtcOnly) {
                                                    return (
                                                        <div className="event-survey__row event-survey__row--etc-only" key={option.optionId}>
                                                            <div className="event-survey__content">
                                                                <input
                                                                    type="text"
                                                                    className="event-survey__etc"
                                                                    placeholder="기타 (직접입력)"
                                                                    maxLength={200}
                                                                    disabled={isRegistered}
                                                                    value={surveyShortAnswers[`${question.seq}_${option.optionId}`] || ''}
                                                                    onChange={(e) =>
                                                                        handleEtcOnlyChange(
                                                                            question,
                                                                            option.optionId,
                                                                            e.target.value,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <label className="event-survey__row" key={option.optionId}>

                                                        {!isRegistered ? (
                                                            <div style={{ marginLeft: '7px' }}>
                                                                <input
                                                                    type={isSingle ? 'radio' : 'checkbox'}
                                                                    name={`survey-question-${question.seq}`}
                                                                    value={option.optionId}
                                                                    checked={answers.includes(option.optionId)}
                                                                    onChange={(e) =>
                                                                        handleSurveyAnswerChange(
                                                                            question,
                                                                            option.optionId,
                                                                            e.target.checked,
                                                                        )
                                                                    }
                                                                />
                                                                <span className="event-survey__check" aria-hidden="true" />
                                                            </div>
                                                        ) : <div />}

                                                        <div className="event-survey__number">
                                                            {index + 1}
                                                        </div>

                                                        <div className="event-survey__content">
                                                            {isEtc && !isRegistered ? (
                                                                <input
                                                                    type="text"
                                                                    className="event-survey__etc"
                                                                    placeholder="기타 (직접입력)"
                                                                    maxLength={200}
                                                                    disabled={!answers.includes(option.optionId)}
                                                                    value={surveyShortAnswers[`${question.seq}_${option.optionId}`] || ''}
                                                                    onChange={(e) =>
                                                                        handleSurveyShortAnswerChange(
                                                                            `${question.seq}_${option.optionId}`,
                                                                            e.target.value,
                                                                        )
                                                                    }
                                                                />
                                                            ) : (
                                                                option.optionText
                                                            )}
                                                        </div>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        {hasValidGift && (
                            <div className="event-gift" style={{ maxWidth: '100%', padding: '15px 130px' }}>
                                {/* {isRegistered ? <h4 className="event-gift__title">사은품</h4> : <h4 className="event-gift__title">사은품 선택</h4>} */}
                                <h4 className="event-gift__title">사은품 선택</h4>
                                <div className="event-gift__list">
                                    {validGifts.map((gift) => (
                                        <label
                                            className="event-gift__item"
                                            htmlFor={`event-gift-${gift.giftId}`}
                                            key={gift.giftId}
                                        >

                                            {!isRegistered ? (
                                                <>
                                                    <input
                                                        id={`event-gift-${gift.giftId}`}
                                                        type="radio"
                                                        name="event-gift"
                                                        value={gift.giftId}
                                                        onChange={handleGiftChange}
                                                    />
                                                    <span className="event-gift__check" aria-hidden="true" />
                                                </>
                                            ) : <span />}

                                            <span className="event-gift__thumb">
                                                {gift.webImgName && (
                                                    <img
                                                        src={`${BASE_URL}/gift/${gift.webImgName}`}
                                                        alt={gift.giftName}
                                                    />
                                                )}
                                            </span>

                                            <span className="event-gift__label">
                                                {gift.giftName}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        )}
                        {isRegistered && (
                            <p style={{ color: 'red', textAlign: 'center', margin: '10px', fontSize: '18px' }}>이벤트 참여 완료</p>
                        )}

                        {!isRegistered && (
                            <div className="event-submit" style={{ display: 'flex', justifyContent: 'end' }}>
                                <Link to="/pagab010" className="vln-listbtn">
                                    목록
                                </Link>
                                <button className="vln-listbtn" type="button" onClick={handleSubmitEvent}>
                                    제출하기
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default PAGAB020;
